import template from './requestQuestion.html';
import controller from './requestQuestion.controller';
import './requestQuestion.scss';

let requestQuestionComponent = {
  restrict: 'E',
  bindings: {
    text: '@',
    buttonTextOne: '@',
    buttonTextTwo: '@',
    modalId: '@',
    onSelection: '&',
    isInception: '<',
    startDate: '<',
    yearPagination: '<'
  },
  template,
  controller,
};

export default requestQuestionComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestQuestion/requestQuestion.component.js